module.exports = __webpack_public_path__ + "img/beauty.5e60ab95.svg";